import React from 'react';
import { clsx } from 'clsx';

import { StatsItemProps } from '../..';
import { IconArrowNarrowDown, IconArrowNarrowUp } from '@/components/icons';

export const StatsItem: React.FC<StatsItemProps> = ({ title, value, description, highlight }) => {
  const isNegative = highlight?.includes('-');
  const ArrowIcon = isNegative ? IconArrowNarrowDown : IconArrowNarrowUp;
  return (
    <div>
      <div className="px-4 py-5 sm:p-6">
        <dl>
          <dt className="text-base leading-6 font-normal text-gray-500">{title}</dt>
          <dd aria-label={title} className="mt-1 flex justify-between items-baseline lg:flex">
            <div className="flex items-baseline text-2xl leading-8 text-gray-900">
              {value}
              {description && <span className="ml-2 text-sm leading-5 font-medium text-gray-500">{description}</span>}
            </div>

            {highlight && (
              <div
                className={clsx(
                  'inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium leading-5 md:mt-2 lg:mt-0',
                  isNegative ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'
                )}
              >
                <ArrowIcon
                  title={`${title}-relativo`}
                  className={clsx(
                    '-ml-1 mr-0.5 flex-shrink-0 self-center',
                    isNegative ? 'text-red-500' : 'text-green-500'
                  )}
                />
                <span className="sr-only">Relativo</span>
                {highlight}
              </div>
            )}
          </dd>
        </dl>
      </div>
    </div>
  );
};
